<template>
  <div class="w-7/12">
    <SwdRemoteSearch class="w-5/12" />
  </div>
  <!-- <div class="w-2/12 flex justify-center">
    <InlineSvg :src="IrisLogoStandart" width="100" height="40" />
  </div> -->
  <div class="w-5/12 flex justify-end">
    <SelectAdvisors />
    <HeaderNotificationsBlock class="mx-4" />
    <UserAction />
  </div>
</template>

<script>
import IrisLogoStandart from '@/assets/svg/iris-logo-standard.svg'
import SwdRemoteSearch from '@/components/Global/SwdRemoteSearch.vue'
import HeaderNotificationsBlock from '@/components/Header/HeaderNotificationsBlock.vue'
import SelectAdvisors from '@/components/Header/SelectAdvisors.vue'
import UserAction from '@/components/UserAction.vue'

export default {
  name: 'AssistantHeader',
  components: {
    UserAction,
    SwdRemoteSearch,
    HeaderNotificationsBlock,
    SelectAdvisors,
  },
  setup() {
    let role = null
    let email = null
    let username = null

    try {
      const storedData = localStorage.getItem('role')
      if (storedData) {
        const parsedData = JSON.parse(storedData)
        role = parsedData?.globalComponents?.role
      }
    } catch (error) {
      console.error('Error parsing role data from localStorage:', error)
    }

    try {
      const storedTRCMData = localStorage.getItem('TRCMData')
      if (storedTRCMData) {
        const parsedTRCMData = JSON.parse(storedTRCMData)
        email = parsedTRCMData?.globalComponents?.TRCMData?.email
        if (email) {
          username = email.split('@')[0]
        }
      }
    } catch (error) {
      console.error('Error parsing TRCMData from localStorage:', error)
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'user_data_push',
      iris_user: username,
      iris_user_type: role,
    })
    return {
      IrisLogoStandart,
    }
  },
}
</script>
